import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './pec-import.routes';
import api from '../../../components/api-service';
import util from '../../../components/util/util.module';
import emailService from '../../../components/email-service';
import 'angular-translate';
import feconClientBundle from '@infocert/fecon-client-bundle';
const translateModule = 'pascalprecht.translate';

export class PecImportController {

  constructor (notifier, $state, EmailService) {
    'ngInject';

    this.notifier = notifier;
    this._$state = $state;
    this._emailService = EmailService;
  }

  $onInit() {
    this.email = this._emailService.getEmailUser() + '@' + this._emailService.getEmailDomain();
    this.accessType = this._emailService.getAccessType();
  }
}

export default angular.module('lmrcApp.pec-import', [
  uiRouter,

  translateModule,

  feconClientBundle,

  util,
  api,
  emailService

])
  .config(routing)
  .component('pecImport', {
    template: require('./pec-import.html'),
    controller: PecImportController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/features/pec-import/index.js